export const ROOT_ROUTE = '';
export const DOCTORS_ROUTE = `${ROOT_ROUTE}/doctors`;
export const SPECIALITIES_ROUTE = `${ROOT_ROUTE}/specialities`;
export const CLIENT_DETAILS = `${ROOT_ROUTE}/client-details`;
export const MEDICARE_AND_HEALTH = `${ROOT_ROUTE}/medicare-and-health`;
export const REVIEW = `${ROOT_ROUTE}/review`;
export const THANKS = `${ROOT_ROUTE}/thanks`;
export const BOOK_ADHD_QUESTIONNAIRE = '/adhd/questionnaire/*';
export const BOOK_ADHD = '/adhd/*';
